export interface IdentityUser {
  id: string | number;
  login?: string;
  integrador?: boolean;
  integradorId?: string | number;
  contas?: unknown[];
}

export interface SessionIdentityInput {
  user: IdentityUser;
  tenantId: number | undefined;
  locale: string | undefined;
}

export interface RawSessionIdentity {
  user: unknown;
  tenant: unknown;
  locale: string | undefined;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function isIdentifiableUser(value: unknown): value is IdentityUser {
  if (!isObject(value)) {
    return false;
  }
  const { id } = value;
  return (typeof id === 'string' || typeof id === 'number') && Boolean(id);
}

/** Lê `id` numérico do tenant decodificado; qualquer outra forma vira undefined. */
export function resolveTenantId(tenant: unknown): number | undefined {
  if (!isObject(tenant)) {
    return undefined;
  }
  const { id } = tenant;
  return typeof id === 'number' ? id : undefined;
}

/** Devolve o insumo da identificação, ou null quando a sessão não tem usuário identificável. */
export function resolveIdentityInput(raw: RawSessionIdentity): SessionIdentityInput | null {
  if (!isIdentifiableUser(raw.user)) {
    return null;
  }
  return {
    // O objeto segue como veio: copiar campos criaria uma segunda fonte de verdade para o payload.
    user: raw.user,
    tenantId: resolveTenantId(raw.tenant),
    locale: raw.locale || undefined,
  };
}
